import { create } from 'zustand';

import {
} from '@/erp/mantenimiento-operacion/planificadores/shared/components';
import { Nullable } from '@/shared/interfaces';
import { fechasArrObj, Flota, HorarioCalendar, Planificador, PlanificadorEvent, TimeMapPlanificador } from '@/shared/interfaces/erp/mantenimiento-operaciones';
import dayjs, { Dayjs } from 'dayjs';
import { getFlota, getPlanificadores } from '@/shared/actions/erp';
import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(isoWeek);

interface PlanificadorStore {
  fechasArrObj: fechasArrObj[];
  setFechasArrObj: (fechasArrObj: fechasArrObj[]) => void;

  selectedEvent: Nullable<PlanificadorEvent>;
  selectedFlota: Nullable<Flota>;
  selectedPlanificador: Nullable<Planificador>;

  minDate: Dayjs | null;
  setMinDate: (minDate: Dayjs | null) => void;

  maxDate: Dayjs | null;
  setMaxDate: (maxDate: Dayjs | null) => void;

  handleStartPlanificador: (codFlota: string) => void;
  handleChangeDatePicker: (date: Dayjs | null) => void;
  handleRefreshPlanificador: (timeMap: TimeMapPlanificador[]) => void;

  isLoadingCalender: boolean;
  setIsLoadingCalender: (isLoadingCalender: boolean) => void;

  // multiple events - select multiple slots to block multiple events -------
  selectedEventsArray: PlanificadorEvent[];
  setSelectedEventsArray: (events: PlanificadorEvent[]) => void;
  isFetchingEvents: boolean;
  setIsFetchingEvents: (fetching: boolean) => void;
  newHorarioArr: HorarioCalendar[];
  setNewHorarioArr: (horarios: HorarioCalendar[]) => void;
  events: PlanificadorEvent[];
  setEvents: (events: PlanificadorEvent[]) => void;
  // ------

  setSelectedEvent: (event: Nullable<PlanificadorEvent>) => void;
  setSelectedFlota: (flota: Nullable<Flota>) => void;
  setSelectedPlanificador: (planificador: Nullable<Planificador>) => void;

  // custom block time ---
  isOpenCustomBlockTime: boolean;
  setIsOpenCustomBlockTime: (open: boolean) => void;
  mondayToSunday: string[];
  setSelectedMondayToSunday: (days: string[]) => void;
  isOpenCustomUnblockTime: boolean;
  setIsOpenCustomUnblockTime: (open: boolean) => void;

  prevMondayDatePicker: Dayjs | null;
  setPrevMondayDatePicker: (prevMondayDatePicker: Dayjs | null) => void;

  valueDatePicker: Dayjs | null;
  setValueDatePicker: (valueDatePicker: Dayjs | null) => void;
}

export const usePlanificadorStore = create<PlanificadorStore>(set => ({

  fechasArrObj: [],
  setFechasArrObj(fechasArrObj) {
    set({ fechasArrObj })
  },

  valueDatePicker: null,
  setValueDatePicker: (valueDatePicker: Dayjs | null) => {
    set({ valueDatePicker })
  },
  isLoadingCalender: false,
  setIsLoadingCalender(isLoadingCalender) {
    set({ isLoadingCalender })
  },
  minDate: null,
  setMinDate(minDate) {
    set({ minDate })
  },
  maxDate: null,
  setMaxDate(maxDate) {
    set({ maxDate })
  },
  prevMondayDatePicker: dayjs(new Date),
  setPrevMondayDatePicker(prevMondayDatePicker) {
    set({ prevMondayDatePicker })
  },
  selectedEvent: null,
  selectedFlota: null,
  selectedPlanificador: null,

  // multiple events/slots to block/unblock
  selectedEventsArray: [],
  setSelectedEventsArray: events => {
    set({ selectedEventsArray: events });
  },
  isFetchingEvents: false,
  setIsFetchingEvents: fetching => {
    set({ isFetchingEvents: fetching });
  },
  newHorarioArr: [],
  setNewHorarioArr: horarios => {
    set({ newHorarioArr: horarios });
  },
  events: [],
  setEvents: events => {
    set({ events });
  },
  // --------------------------------

  // custom block time -----------
  isOpenCustomBlockTime: false,
  setIsOpenCustomBlockTime: open => {
    set({ isOpenCustomBlockTime: open });
  },
  mondayToSunday: [],
  setSelectedMondayToSunday: days => {
    set({ mondayToSunday: days });
  },
  isOpenCustomUnblockTime: false,
  setIsOpenCustomUnblockTime: open => {
    set({ isOpenCustomUnblockTime: open });
  },
  // -----------------------------

  setSelectedEvent: event => {
    set({ selectedEvent: event });
  },
  setSelectedFlota: flota => {
    set({ selectedFlota: flota });
  },
  setSelectedPlanificador: planificador => {
    set({ selectedPlanificador: planificador });
  },
  handleStartPlanificador: async (idFlota) => {


    try {
      ///*Obtener flota

      set({ isLoadingCalender: true })

      const respFlota = await getFlota(idFlota)

      set({ selectedFlota: respFlota?.data })

      ///* Obtener todos los planificadores
      let resp = await getPlanificadores({
        page_size: 1,
        flota_codigo_exact: respFlota?.data.codigo,
        fecha_inicio_exact: dayjs().startOf('isoWeek').format('YYYY-MM-DD')
      })

      const dataPlanificador = resp.data.data;

      set({
        maxDate: dayjs(dataPlanificador.at(0)?.fecha_maxima),
        minDate: dayjs(dataPlanificador.at(0)?.fecha_minima),
        valueDatePicker: dayjs(dataPlanificador.at(-1)?.fecha_inicio),
        prevMondayDatePicker: dayjs(dataPlanificador.at(-1)?.fecha_inicio),
        selectedPlanificador: dataPlanificador.at(-1),
        mondayToSunday: [dataPlanificador.at(-1)?.fecha_inicio!, dataPlanificador.at(-1)?.fecha_fin!]
      })

    } catch (error) {

    } finally {
      set({ isLoadingCalender: false })

    }
  },
  handleChangeDatePicker: async (date) => {

    if (!date) return;

    try {
      set({ isLoadingCalender: true })

      const prevMonday = date.startOf('isoWeek');

      const {
        selectedFlota,
        prevMondayDatePicker
      } = usePlanificadorStore.getState();

      if (prevMonday.format('YYYY-MM-DD') ==
        prevMondayDatePicker?.format('YYYY-MM-DD')) return;


      const respP = await getPlanificadores({
        flota_codigo_exact: selectedFlota?.codigo,
        fecha_inicio_exact: prevMonday?.format('YYYY-MM-DD') ?? '',
        page_size: 10
      });

      if (respP.code !== 200) return;

      const dataPlanificador = respP.data.data;
      set({ selectedPlanificador: dataPlanificador.at(0) })
      set({ valueDatePicker: date })
      set({ prevMondayDatePicker: prevMonday })

      set({ mondayToSunday: [dataPlanificador.at(0)?.fecha_inicio!, dataPlanificador.at(0)?.fecha_fin!] });


    } catch (error) {

      console.log(error, 'error catch date picker');


    } finally {
      set({ isLoadingCalender: false })

    }

  },
  handleRefreshPlanificador: async (timeMap: TimeMapPlanificador[]) => {
    console.log('refresh planificador');
    try {
      set({ isLoadingCalender: true })
      const {
        selectedPlanificador
      } = usePlanificadorStore.getState();

      const dataPlanificador: any = {
        ...selectedPlanificador,
        time_map: timeMap
      };
      set({ selectedPlanificador: dataPlanificador })

    } catch (error) {

    } finally {
      set({ isLoadingCalender: false })
    }
  }

}));